<template>
  <div>
 
    <div  id="container" style="height:600px;"></div>
		<DxPopup
      :visible.sync="paused "
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="350"
      :height="50"
      title="Paused: Space Toggles"
    >
		<DxPosition at="center" offset="0 -200"></DxPosition>
	</DxPopup>

	<DxPopup
      :visible.sync="loadingModel"
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
	  :showCloseButton="false"
      :show-title="true"
      :width="280"
      :height="50"
      :title="progDesc"
	 	
    >   
	<DxPosition at="bottom" offset="0 -100"></DxPosition>
    </DxPopup>
		<DxPopup
      :visible.sync="popupVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="300"
      :height="300"
      title="Lighthouse"
    >
	
		Movement<br>
		W:Forward<br>
		A:left<br>
		S:Back<br>
		D:Right<br>


      
      
    </DxPopup>
	
  </div>
</template>

<script>

var paused=false
var loadingModel=false

export default {
	props:{
		screenVis: { default:false},
		videoShowing: { default:false}
	},
	
   	components: {
		   DxPopup,DxPosition,DxAt,DxOffset,
  },

		data: () => ({
			popupVisible: false,
			paused:false,
			loadingModel:false,
			wallLight:null,
			lights:[],
			prog:0,
			progDesc:"Loading Model",
			switches:[],
			distance:0,
			itemsLoaded:0,
			wrecks:[
				{name:"bomber",played:false,opts:{model:"/lighthouse/Book",scale:8,rotX:.1,rotY:Math.PI/2.5,pos:{x:0,y:-83,z:-22}}},
				{name:"bermagui",played:false,opts:{model:"/lighthouse/bermaguiLatern",scale:3,rotX:.1,rotY:Math.PI/3,pos:{x:0,y:-88,z:-22}}},
				{name:"enterprise",played:false,opts:{model:"/lighthouse/SecretInstructions",scale:4.8,rotX:.1,rotY:0,pos:{x:0,y:-88,z:-22}}},
				{name:"pandemonium",played:false,opts:{model:"/lighthouse/PandoBottle",scale:9,rotX:.1,rotY:0,pos:{x:0,y:-88,z:-22}}},
				{name:"verdoemd",played:false,opts:{model:"/lighthouse/verdomedPistol",scale:5,rotX:0,rotY:0,rotZ:0,pos:{x:0,y:-58,z:-52}}},
				{name:"sub",played:false,opts:{model:"/lighthouse/SubBuddha",scale:10,rotX:0,rotY:0,rotZ:0,pos:{x:-10,y:-88,z:-22}}}	
			]
			
		}),

		mounted(){
			
			Vue=this
			isRunning=true
			init();
			paused=false
			animate();
			requestAnimationFrame( this.checkStatus );
			document.addEventListener('keyup', this.keyUp);
			this.enableControls()
		},
		computed:{
			fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
			},
			unlockedScenes(){
				return this.wreckStatus.scenes
			},
			debug(){
      			return this.$store.getters.getDebug
    		},
			userData(){
				return this.$store.getters.getUserData
				},
			userIsLoaded(){
				return this.$store.getters.getUserIsLoaded
			},
			locCount(){
				let locCount=0
				if(this.wreckStatus){
					for(var i in this.wreckStatus.knownDocs){
						if(this.wreckStatus.knownDocs[i].indexOf("Loc-")>-1){
							locCount++
						}
					}
				}
				return locCount
			},
			wreckStatus(){
				if(this.selectedWreck){
					return this.$store.getters.getWreckStatus[this.selectedWreck.id]
				}else{
					return null
				}
      		},
			showSignIn(){
      			return this.$store.getters.showSignIn
    		},
			selectedWreck(){
				return this.$store.getters.getWreck
			}
		},
		methods:{
			loadModelM(target,opts){
				console.log("LOAD ",target,opts)
				loadingModel=true
				//no spaces
				
				const material = new THREE.MeshPhongMaterial({
					emissive: 0xff0000,
					emissiveIntensity:.1,
					opacity: 1,
					transparent: false,
					});
				
				let modelPath
				if(opts.model){
					modelPath='./models/'+opts.model
				}else{
					return
				}
				let instance
				let textureMap
				
				console.log("loading ",modelPath)
				const loaderM = new GLTFLoader();

				loaderM.load(modelPath, gltfM => {
					gltfM.scene.traverse( child => {
						if ( child.material ) {
							//child.material.emissive = 0xffffff
							//child.material.emissiveIntensity = .5
							child.material.metalness = 0;
						}
						if(child.name.indexOf("LIGHT")>-1){
							this.wallLight=child
							this.lights.push(child)
							child.children[3].material.color.setHex( 0x333333 );					
						}else if(child.name.indexOf("switch")>-1){
							this.switches.push(child)
						}else if(child.name.indexOf("Plan")>-1){
							if(child.name=="Plan1" ){
								var texture = new THREE.TextureLoader().load(this.fireBaseLoc+'images%2FMaps%2FWSWorldMap.jpg' );
								texture.wrapS = THREE.RepeatWrapping;
								texture.center.set( 0.5,0.5);texture.rotation = Math.PI;
								texture.repeat.x = - 1;
								var materialT = new THREE.MeshBasicMaterial( { map: texture } );
								child.material=materialT
							}else if(child.name=="Plan2"){
								var texture = new THREE.TextureLoader().load( this.fireBaseLoc+ 'images%2FMaps%2FMap_Australia.jpg' );
								texture.wrapS = THREE.RepeatWrapping;
								texture.center.set( 0.5,0.5);
								texture.rotation = Math.PI;
								texture.repeat.x = - 1;
								var materialT = new THREE.MeshBasicMaterial( { map: texture } );
								child.material=materialT	
							}else if(child.name=="Plan"){
								var texture = new THREE.TextureLoader().load(require( '../assets/images/exhibit/layout3.png' ));
								texture.wrapS = THREE.RepeatWrapping;
								texture.center.set( 0.5,0.5);
								texture.rotation = Math.PI;
								texture.repeat.x = - 1;
								var materialT = new THREE.MeshBasicMaterial( { map: texture } );
								child.material=materialT	
							}
							
							console.log(child.name)
							objects.push(child)
						}else{
							//console.log(child.name)
						}
					})
					//this.setLight(1)

					target.add(gltfM.scene)
					if(opts.posY){
						gltfM.scene.position.set(0,opts.posY,0)
					}else{
						gltfM.scene.position.set(0,50,0)
					}
					if(opts.pos){
						gltfM.scene.position.set(opts.pos.x,opts.pos.y,opts.pos.z)
					}
					if(opts.rotX){
						gltfM.scene.rotateX(opts.rotX)
					}
					if(opts.rotY){
						gltfM.scene.rotateY(opts.rotY)
					}
					if(opts.rotZ){
						gltfM.scene.rotateZ(opts.rotZ)
					}
					if(opts.scale){
						gltfM.scene.scale.set(opts.scale,opts.scale,opts.scale)
					}else{
						gltfM.scene.scale.set(50,50,50)
					}
					loadWeckContent()
					
					},
					this.loadProgLH,this.loadError)
				
			},
				
				loadModel(target,opts){
					console.log("loadModel",target,opts)
					//return
				//no spaces
				loadingModel=true
				const material = new THREE.MeshPhongMaterial({
					emissive: 0x000000,
					color:0x7777777,
					emissiveIntensity:1,
					opacity: 1,
					transparent: true,
					depthTest:false
					});
				
				let modelPath='./models/unknown.gltf'
				if(opts.model){
					modelPath='./models/'+opts.model+'.gltf'
				}
				let instance
				let textureMap
				
				console.log("loading ",modelPath)
				const loaderM = new GLTFLoader();

				loaderM.load(modelPath, gltfM => {
					gltfM.scene.traverse( child => {
						if ( child.material ) {
							textureMap=child.material.map
							child.material=material
							child.material.map=textureMap
							child.material.emissiveMap=textureMap
							objects.push(child)
						}
						
					})
					
					
					
					target.add(gltfM.scene)
					if(opts.posY){
						gltfM.scene.position.set(0,opts.posY,0)
					}else{
						gltfM.scene.position.set(0,50,0)
					}
					if(opts.pos){
						gltfM.scene.position.set(opts.pos.x,opts.pos.y,opts.pos.z)
					}
					if(opts.rotX){
						gltfM.scene.rotateX(opts.rotX)
					}
					if(opts.rotY){
						gltfM.scene.rotateY(opts.rotY)
					}
					if(opts.rotZ){
						gltfM.scene.rotateZ(opts.rotZ)
					}
					if(opts.scale){
						gltfM.scene.scale.set(opts.scale,opts.scale,opts.scale)
					}else{
						gltfM.scene.scale.set(50,50,50)
					}
					//scene.add(gltfM.scene);
					//loadingModel=false
					this.itemsLoaded++
					if(this.itemsLoaded == this.wrecks.length-1){
						loadingModel=false
					}
					console.log("LOADED",this.itemsLoaded)
					},
					this.loadProg,this.loadError)
				
			},
			loadProgLH(p){
				
				this.prog=Math.floor(Math.min(100,p.loaded/p.total*100))
				this.progDesc="Loading lighthouse "+this.prog+"%"
				//console.log("Loading "+this.prog+"%")
			},
			loadProg(p){
				this.prog=Math.floor(Math.min(100,p.loaded/p.total*100))
				this.progDesc="Loading item "+(this.itemsLoaded+1)+" of "+this.wrecks.length
				
				//this.prog="..."//Math.floor(p.loaded/p.total*100)
				//console.log("Loading "+this.prog+"%")
			},
			transTo(page,text){
				let tText=text || "Meanwhile"
				this.$store.dispatch('startTransition',{text:tText,to:page})
			},
			showScreen(object){
				if(object.name.indexOf("Plan")>-1){
					this.isRunning=false
					if(object.name=="Plan1"){
						if(!this.selectedWreck){
							  this.$store.dispatch("showBasicHelp","You need to have selected a wreck before you can plan your dive")
							//alert("NO WRECK SELECTED")
						}else{
							console.log(this.selectedWreck,this.wreckStatus,this.locCount)
							if(this.locCount>2){
								this.transTo('planning',' ')
							}else{
								 this.$store.dispatch("showBasicHelp","You don't have enough locations discovered to start planning your dive yet")
      
							}
							//alert(this.selectedWreck.name)
							//this.transTo('planning',' ')
						}
						
						
					}else{
						if(!this.selectedWreck){
							  this.$store.dispatch("showBasicHelp","You need to have selected a wreck before you can plan your exhibition")
							  //alert("NO WRECK SELECTED")
						}else{
							if(this.userIsLoaded){
								if(this.wreckStatus){

								}
								console.log("this.wreckStatus",this.wreckStatus.collectedItems)
								console.log("this.wreckStatus",this.wreckStatus.scannedItems)
								if(Object.keys(this.wreckStatus.collectedItems).length+Object.keys(this.wreckStatus.scannedItems).length>5){
									this.transTo('exhibitPlan',' ')
								}else{
 									this.$store.dispatch("showBasicHelp","You haven't collected enough items for an exhibition")
							 
								}
								
							}else{
								 this.$store.dispatch("showBasicHelp","You need to be logged in to create an exhibition")
							 
							}
							
						}
					}
					
				}else{
					console.log("SHOW SCREEN OBJECT",object)
					if(object.name=="Sample_Book"){
						object=object.parent.parent
					}
					if(!this.screenVis){
						
						this.$emit('objectClick',object)
					}
				}
			
			},
			checkStatus(){
				
				this.loadingModel=loadingModel
				requestAnimationFrame( this.checkStatus );
			},
		keyUp(e){
				switch(e.key){
					case " ":
						console.log("pause")
						this.paused=!this.paused
						paused=this.paused
						break
				
				}
			},
			enableControls(){
				//return
					this.disableControls()
					document.addEventListener('keyup', this.keyUp);
					document.addEventListener( 'mousedown', onDocumentMouseDown );
					controls = new FirstPersonControlsTouch( camera, document);//renderer.domElement );
					//controls = new CameraControls( camera, renderer.domElement );
					//controls = new DragControls( camera, renderer.domElement );
					controls.movementSpeed = 100;
					controls.lookSpeed = 0.05;
					controls.constrainVertical=true;
					controls.verticalMax=Math.PI/3.5
					controls.verticalMin=Math.PI/1.6
					if(!this.screenVis){
						paused=false
					}
					console.log("ENABLED")
					
			},
			disableControls(){
				//return
				document.removeEventListener('keyup', this.keyUp);
				document.removeEventListener( 'mousedown', onDocumentMouseDown );
				controls.dispose()
				paused=true
			}
	   
		},
		watch:{
			debug(val){
				if(val){
					container.appendChild( stats.dom );
				}else{
					container.removeChild( stats.dom );
				}
			},
			showSignIn(val){
				
				if(val){
					this.disableControls()
				}else{
					this.enableControls()
				isRunning=true
				}
			},
			selectedWreck(val){
				
				if(!isNaN(val.index)){
					lightsOn(val.index)
				}
				
				console.log("STATUS",val)
			},
			videoShowing(val){
				paused=this.screenVis || this.videoShowing
				if(!paused){
					animate()
				}
			},
			screenVis(val){
				paused=this.screenVis || this.videoShowing
				if(!paused){
					animate()
				}
			}
		},
		beforeDestroy(){
			document.removeEventListener('keyup', this.keyUp);
			document.removeEventListener( 'mousedown', onDocumentMouseDown );
			controls.dispose()
			isRunning=false
			if ( gui ) gui.destroy();
		}
	};



			import * as THREE from 'three';
			import gsap from "gsap";
			import Stats from 'three/examples/jsm/libs/stats.module.js';
			import * as dat from 'dat.gui';
			//import { DxPopup } from 'devextreme-vue/popup';
			import { DxPopup,DxPosition,DxAt, DxOffset } from 'devextreme-vue/popup';
				
			import * as Nodes from 'three/examples/jsm/nodes/Nodes.js';
			import {ImprovedNoise} from 'three/examples/jsm/math/ImprovedNoise.js';
			import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
			
			import { FirstPersonControlsTouch } from 'three/examples/jsm/controls/FirstPersonControlsTouch.js';
			
			//import { CameraControls } from 'three/examples/jsm/controls/experimental/CameraControls.js';
import { Scene } from 'three';
			


			//import shipPath from '../assets/models/plane26.gltf'
			var Vue
			var camera, scene, renderer;
			var camTarget,camTargetTarget
			var isRunning =true
			var object, light,Alight;
			var personHeight=10
			var objects=[]
			var switches=[]
			var boxes=[]
			var container
			var controls
			var params
			var clock = new THREE.Clock();
			var stats,gui
			var lastGood
			var loadedModel
			var sceneModels={}
			var isUserInteracting = false,
				onMouseDownMouseX = 0, onMouseDownMouseY = 0,
				lon = 0, onMouseDownLon = 0,
				lat = 0, onMouseDownLat = 0,
				phi = 0, theta = 0;
			//
			var mesh,texture, worldWidth = 1024, worldDepth = 1024,
		  	worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
			//init();
			//animate();
			var objGeometry = new THREE.BoxBufferGeometry( 100,160,100 );
			var switchGeometry = new THREE.BoxBufferGeometry( 40,60,100 );
			var materialT = new THREE.MeshPhongMaterial( { color: 0x8080FF, dithering: true,opacity: 0,
					transparent: true, } );
			var spotLight = new THREE.SpotLight( 0xffffff, 5 );
				spotLight.position.set(  0 ,200, -200 );
				spotLight.angle = Math.PI/6 ;
				spotLight.penumbra = 0.25;
				spotLight.decay = 2;
				spotLight.distance = 400;
				spotLight.target.position.set( 0, 0, 0 );
				spotLight.castShadow = false;
				spotLight.shadow.mapSize.width = 1024;
				spotLight.shadow.mapSize.height = 1024;
				spotLight.shadow.camera.near = 10;
				spotLight.shadow.camera.far = 200;
			function init() {
				console.log("INIT")
				container = document.getElementById( 'container' );
				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );
				/*
				//document.addEventListener('mousedown', onDocumentMouseDown, false);
				document.addEventListener( 'mousedown', onPointerStart, false );
				//document.addEventListener( 'mousemove', onPointerMove, false );
				document.addEventListener( 'mouseup', onPointerUp, false );
				document.addEventListener( 'touchstart', onPointerStart, false );
				//document.addEventListener( 'touchmove', onPointerMove, false );
				document.addEventListener( 'touchend', onPointerUp, false );
				//document.body.appendChild( renderer.domElement );
				*/
				//
				var camGeom = new THREE.BoxBufferGeometry( 1,1,1 );
				var camMat = new THREE.MeshPhongMaterial( { color: 0x8080FF, dithering: true,opacity: 0,
					transparent: true, } );
				camTarget = new THREE.Mesh( camGeom, camMat );
				camTargetTarget = new THREE.Mesh( camGeom, camMat );
				camTarget.add(camTargetTarget)
				camTargetTarget.position.set(0,0,10)
				camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 1, 1000 );
				camera.position.z = 0;
				
				//camTarget.position.z=-20
				scene = new THREE.Scene();
				
				object = new THREE.Object3D();
				//scene.add( object );
				//Vue.loadModelM(scene,{model:"LIGHTHOUSEOneLight-3.gltf",scale:1.3,rotX:0,rotY:Math.PI*75.4/180,pos:{x:0,y:-1030,z:0}})
				//Vue.loadModelM(scene,{model:"LIGHTHOUSE.gltf",scale:1.3,rotX:0,rotY:Math.PI*75.4/180,pos:{x:0,y:-1030,z:0}})
				Vue.loadModelM(scene,{model:"LIGHTHOUSE_4.gltf",scale:1.3,rotX:0,rotY:Math.PI*75.4/180,pos:{x:0,y:-1030,z:0}})
			
				 //wall
				var box1,box2,box3,box4,box5,box6
				
				
			

				controls = new FirstPersonControlsTouch( camera, document);//renderer.domElement );
				//controls = new FirstPersonControls( camera, renderer.domElement );
				//controls = new CameraControls( camera, renderer.domElement);//renderer.domElement );
				controls.movementSpeed = 100;
				controls.lookSpeed = 0.05;
				controls.constrainVertical=true;
				controls.verticalMax=Math.PI/3.5
				controls.verticalMin=Math.PI/1.6
				controls.lookVertical =true
				scene.add(camTarget)
				
				//camTarget.position.set(0,0,-11)
				console.log("CAMERA",camera)
				
				Alight = new THREE.AmbientLight( 0x222222 ); // soft white light
				Alight.intensity=3
        		scene.add( Alight );
                scene.fog = new THREE.FogExp2( 0x000000, 0);
				
				light = new THREE.PointLight( 0xffffff, 1, 0 );
				//light = new THREE.DirectionalLight( 0xff00ff, 1 );
				scene.add( light );
				light.intensity=1
				light.position.set( 1, 1, 1 );
				scene.add( light );
				
				//Stats
				stats = new Stats();
				//container.appendChild( stats.dom );
				// GUI
				//createGUI()
				window.addEventListener( 'resize', onWindowResize, false );
			}
			function loadWeckContent(){
				for (var wreck in Vue.wrecks){
					addWreck(boxes[wreck],wreck,Vue.wrecks[wreck].name,Vue.wrecks[wreck].opts)
				
				}
			}
			function addWreck(box,index,name,model){
				var angle=(101+(index)*30)/180*Math.PI
				var boxScale=.7
				var boxDist=550
				box = new THREE.Mesh( objGeometry, materialT);
				box.position.set(Math.sin(angle)*boxDist,0,Math.cos(angle)*boxDist);
				Vue.loadModel(box,model)
				box.scale.set(boxScale,boxScale,boxScale)
				box.rotateY(  angle  );
				scene.add( box );
				addSpotLight(box,spotLight,2)
				box.name=name
				objects.push(box)
				switches[index]=new THREE.Mesh( switchGeometry, materialT );
				box.add(switches[index])
				box.index=index
				switches[index].position.set(-100,-40,-15)
				switches[index].name="Switch"+index
				objects.push(switches[index])
				boxes[index]=box

			}
			
			function addSpotLight(target,spotLight,intensity){
				var spot=spotLight.clone()
				target.add(spot)
				spot.intensity=intensity
				spot.visible = false;
				target.add( spot.target );
				spot.target.position.set( 0, 0, 0 );
			}
			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );
				

			}
		
			function getModelData(child){
				let name=child.name
				let pos=child.position
				let instance=name.split("_")
				
				if(instance.length>1){
					let id=instance.pop()
					
					addToSceneModels(instance.join("_"),{name:name,pos:pos})

				}else{
					addToSceneModels("other",{name:name,pos:pos})
				}

			}
			function addToSceneModels(type,model){
				if(!sceneModels[type]){
					sceneModels[type]=[]
				}
				sceneModels[type].push(model)
			}
			document.addEventListener( 'mousedown', onDocumentMouseDown );
		function onDocumentMouseDown( event ) {
			if(!isRunning || paused){
				return
			}
			event.preventDefault();
			 
            var mouse3D = new THREE.Vector3( ( event.clientX / window.innerWidth ) * 2 - 1,   
                                    -( event.clientY / window.innerHeight ) * 2 + 1,  
                                    0.5 );     
            var raycaster =  new THREE.Raycaster();                                        
			raycaster.setFromCamera( mouse3D, camera );
            var intersects = raycaster.intersectObjects( objects );
			
            if ( intersects.length > 0 ) {
				let objName=intersects[ 0 ].object.name || intersects[ 0 ].object.parent.name
				console.log("SWITCH OBJECTS",intersects[ 0 ].object)
				//intersects[ 0 ].object.material.color.setHex( Math.random() * 0xffffff );
				if(objName.indexOf("Switch")>-1){
					let switchIndex=parseInt(objName.substr(6),10)
					if(Vue.switches[switchIndex].isOn){
						switchOff(switchIndex)
					}else{
						switchOn(switchIndex)
						gsap.delayedCall(1,Vue.showScreen,[Vue.wrecks[switchIndex]])
						gsap.delayedCall(2,switchOff,[switchIndex])
						//Vue.showScreen(Vue.wrecks[switchIndex])
					}
				}else if(objName.indexOf("Plan")>-1){
					Vue.showScreen(intersects[ 0 ].object)
				}else{
					let boxIndex=intersects[ 0 ].object.index || intersects[ 0 ].object.parent.index || intersects[ 0 ].object.parent.parent.index || intersects[ 0 ].object.parent.parent.parent.index

					if(Vue.switches[boxIndex].isOn){
						Vue.$emit('showWreckGui',Vue.wrecks[boxIndex].name)
						//switchOff(boxIndex)
					}else{
						
						if(!Vue.wrecks[boxIndex].played){
							switchOn(boxIndex)
							gsap.delayedCall(1,Vue.showScreen,[Vue.wrecks[boxIndex]])
							gsap.delayedCall(2,switchOff,[boxIndex])
							//Vue.showScreen(Vue.wrecks[boxIndex])
							Vue.wrecks[boxIndex].played=true
						}else{
							lightsOn(boxIndex)
							gsap.delayedCall(0,function(){
								Vue.$emit('showWreckGui',Vue.wrecks[boxIndex].name)
							})
							
						}
					}
				}
				
			}else{
				
			}
			
		}
		function switchOff(switchIndex){
			Vue.switches[switchIndex].isOn=false
			gsap.to(Vue.switches[switchIndex].children[0].rotation, 1, {x: -Math.PI /2});		
		}
		function switchOn(switchIndex){
				Vue.switches[switchIndex].isOn=true
				gsap.to(Vue.switches[switchIndex].children[0].rotation, 1, {x: Math.PI /2});
				console.log("Switch",boxes[switchIndex])
				lightsOn(switchIndex)	
		}
		function lightsOn(index){
			
			for(var b in boxes){
				if(b!=index){
					boxes[b].children[0].intensity=1
					boxes[b].children[0].visible = false;
					if(Vue.switches[b]){
						gsap.to(Vue.switches[b].children[0].rotation, 1, {x: -Math.PI /2});
					}
					
				}	
			}
			if(boxes[index]){
				boxes[index].children[0].visible = true;
				boxes[index].children[0].intensity=5
			}else{
				console.log("Nothing to turn on")
			}
			
		}
		function onPointerStart( event ) {
			 event.preventDefault();
				//("START")
				/*isUserInteracting = true;

				var clientX = event.clientX || event.touches[ 0 ].clientX;
				var clientY = event.clientY || event.touches[ 0 ].clientY;

				onMouseDownMouseX = clientX;
				onMouseDownMouseY = clientY;

				onMouseDownLon = lon;
				onMouseDownLat = lat;
	*/
			}

			function onPointerMove( event ) {
				/*
				if ( isUserInteracting === true ) {

					var clientX = event.clientX || event.touches[ 0 ].clientX;
					var clientY = event.clientY || event.touches[ 0 ].clientY;

					lon = ( onMouseDownMouseX - clientX ) * 0.1 + onMouseDownLon;
					lat = ( clientY - onMouseDownMouseY ) * 0.1 + onMouseDownLat;

				}
					*/
			}

			function onPointerUp() {

				isUserInteracting = false;

			}
			
			function animate() {
				if(isRunning){
					
					requestAnimationFrame( animate );
					update();
				}
				

			}
			var vec,pos,dir,sph
			function update() {
				console.log("LH")
					var time = performance.now() * 0.001;
					var deltaTime=clock.getDelta()
					if(!paused){
						
						vec = new THREE.Vector3( 0, 0, -200 );
						vec.applyQuaternion( camera.quaternion );
				
						lastGood={x:controls.object.position.x,y:controls.object.position.y,z:controls.object.position.z}
					
						pos = new THREE.Vector3();
						camTargetTarget.getWorldPosition(pos)
						controls.update( deltaTime );
					
						//controls.update( deltaTime );
						camera.position.y=personHeight
						camTarget.position.copy(controls.object.position)
						dir = new THREE.Vector3();
						sph = new THREE.Spherical();
						camera.getWorldDirection(dir);
						sph.setFromVector3(dir);
					
						camTarget.rotation.y=sph.theta
						camTarget.position.y=0
						if(pos.x*pos.x+pos.z*pos.z>80000){
						
							controls.object.position.set(lastGood.x,lastGood.y,lastGood.z)
						}
					renderer.render( scene, camera );
				}
				stats.begin();

					// monitored code goes here

				stats.end();
				
				
				
			}
				function createGUI(){
		// GUI
		console.log(gui)
		if ( gui ) {
			 try{
				gui.destroy();
			}
			catch(err){
			}	
		}
		
	class FogGUIHelper {
    		constructor(fog, backgroundColor) {
      			this.fog = fog;
      			this.backgroundColor = backgroundColor;
    		}
			get near() {
				return this.fog.near;
			}
			set near(v) {
				this.fog.near = v;
				this.fog.far = Math.max(this.fog.far, v);
			}
			get far() {
				return this.fog.far
			}
			set far(v) {
				this.fog.far = v;
				this.fog.near = Math.min(this.fog.near, v);
			}
			get color() {
				return `#${this.fog.color.getHexString()}`;
			}
			set color(hexString) {
				this.fog.color.set(hexString);
				this.backgroundColor.set(hexString);
			}
		}						
  	
		const color = '#000000';
		const near = 0;
		const far = 50000;
		scene.fog = new THREE.Fog(color, 0, 10000);
		scene.background = new THREE.Color(color);
		const fogGUIHelper = new FogGUIHelper(scene.fog, scene.background);
   
  
		gui = new dat.GUI();
		var fogOptions={
			color:scene.fog.color
		}
		params={
			showWireFrame:false,
			waterDistort:false,
			showRays:true
		}
		var folder = gui.addFolder( 'Global Light' );
		folder.add( Alight, 'intensity', 0, 10, .1 ).name( 'Ambient Light' );
		folder.add( light, 'intensity', 0, 10, .1).name( 'Direction Light' );
		
		var folderFog = gui.addFolder( 'Fog' );
		folderFog.add(fogGUIHelper, 'near', near, far).listen();
   		folderFog.add(fogGUIHelper, 'far', near, far).listen();
		folderFog.addColor(fogGUIHelper, 'color');
		
		


			//folder.open();
		//
	}
	//

		</script>


<style scoped>

</style>